import {GET} from '../constants/API_CONSTANTS';
import {API_GET_AGGREGATION_PLATFORM_SETTINGS} from '../constants/API_ENDPOINTS';
import {request} from '../utils/request';

const getAggregationPlatformSettingsApi = async (locationId) => {
  return request(GET, API_GET_AGGREGATION_PLATFORM_SETTINGS(locationId));
};

export default getAggregationPlatformSettingsApi;
